import * as React from "react";
import { viewDateTimeUtc } from "src/common/formats";
import { Button, Drawer } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import { ZAuditEvent } from "../EntityHistory/EntityAudit/ZEntityAudit";
import styles from "./AuditBanner.module.less";
import { EntityAuditList } from "../EntityHistory/EntityAudit/EntityAuditList";
import { EntityAuditStore } from "../EntityHistory/EntityAudit/EntityAuditStore";

interface PropsAuditBanner {
  event: ZAuditEvent;
  disabled: boolean;
  onAuditEvent(event: ZAuditEvent | null): void;
  auditStore: EntityAuditStore;
}

export const AuditBanner: React.FC<PropsAuditBanner> = (props) => {
  const { event, disabled, onAuditEvent, auditStore } = props;
  const [drawerVisible, setDrawerVisible] = React.useState(false);
  const clear = () => onAuditEvent(null);
  const open = () => {
    setDrawerVisible(true);
  };
  return (
    <div className={styles.box}>
      <div className={styles.info}>
        Версия от {viewDateTimeUtc(event.timestamp)}
      </div>
      <Button icon={<HistoryOutlined />} onClick={open} />
      <Button disabled={disabled} onClick={clear}>
        Открыть актуальную версию
      </Button>
      <Drawer
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        title="История версий экземпляра"
      >
        <EntityAuditList
          loading={auditStore.loading}
          list={auditStore.list}
          onAuditEvent={(e) => {
            setDrawerVisible(false);
            auditStore.onAuditEvent(e);
          }}
        />
      </Drawer>
    </div>
  );
};
